<div
    class="quickbet-panel"
    id="quickbet-panel"
    data-crlat="quickbetPanel"
    [ngClass]="{ 'quickbet-slide-up': slideUpAnimation, 'quickbet-slide-down': slideDownAnimation, 'quickbet-panel-receipt': isState('receipt') }">
    @if (onBoardingData?.tutorialEnabled) {
        <lazy-component
            moduleUri="@lazy-modules-module/onBoardingTutorial/firstBetPlacement/first-bet-placement.module#OnBoardingFirstBetModule"
            entryComponent="OnBoardingFirstBetComponent"
            [inputs]="{ onBoardingData: onBoardingData }">
        </lazy-component>
    }
    <div class="show-iframe" [ngClass]="{ hidden: showIFrame }">
        @if (!isState('deposit')) {
            <header class="quickbet-header" data-crlat="header">
                @if (isFiveASideBet) {
                    <svg class="qb-header-5-a-side-logo">
                        <use xlink:href="#icon-logo-five-a-side"></use>
                    </svg>
                }
                <span class="qb-header-title" [textContent]="title" data-crlat="header.title"></span>
                @if (showCloseIcon) {
                    <div class="qb-header-close-btn" (click)="closePanel($event)" data-crlat="closeButton">
                        <svg>
                            <use xlink:href="#close-icon"></use>
                        </svg>
                    </div>
                }
            </header>
        }

        <!-- Quickbet MS unavailable panel -->
        @if (selection && selection.error) {
            <div>
                @if (!selection.error.selectionUndisplayed) {
                    <request-error [loadFailed]="selection.error" (reloadFn)="reuseSelection()"> </request-error>
                }
                @if (selection.error.selectionUndisplayed) {
                    <div
                        class="selection-undisplayed-error"
                        [i18n]="'quickbet.betPlacementErrors.' + selection.error.selectionUndisplayed"
                        data-crlat="selectionUndisplayed"></div>
                }
                <div class="quickbet-controls">
                    <button
                        class="qb-left-cta-btn"
                        [disabled]="selection.error.selectionUndisplayed"
                        (click)="addToBetslipFnHandler()"
                        [i18n]="'quickbet.buttons.addToBetslip'"
                        data-crlat="addToBetslipButton"></button>
                    <button class="qb-right-cta-btn" [disabled]="true" [i18n]="'quickbet.buttons.placeBet'" data-crlat="placeBetButton"></button>
                </div>
            </div>
        }

        <!-- Quick Bet Information Panel -->
        @if (isState('initial')) {
            <quickbet-info-panel (externalLinksFn)="closeFnHandler()" data-crlat="infPan.msg"> </quickbet-info-panel>
        }
        @if (serviceClosureService.userServiceClosureOrPlayBreak) {
            <div class="closure-message-container" [textContent]="serviceClosureService.userAccountInfo || 'undefined'"></div>
        }
        @if (isState('initial') && !showIFrame) {
            <quickbet-selection
                [isLogAndQuickBetPending]="loginAndPlaceBets"
                [betslipType]="betslipType"
                [selection]="selection"
                [placeBetPending]="placeBetPending"
                [ycOddsValue]="ycOddsValue"
                [quickDepositFormExpanded]="quickDepositFormExpanded"
                [showIFrame]="showIFrame"
                (placeBetFn)="placeBet()"
                (closeFn)="closePanel()"
                [getFreeBetName]="sysConfig.FiveASide && sysConfig.FiveASide.freeBetName"
                (addToBetslipFn)="addToBetslipFnHandler()"
                [leftBtnLocale]="leftBtnLocale"
                (openQuickDepositFn)="openQuickDeposit()"
                data-crlat="quickbet.selection"
                (firstBetBoostEmit)="firstBetBoostEmit($event)"
                [isLuckyDip]="isLuckyDip"
                [luckyDipCmsData]="luckyDipCmsData"
                [luckyDipMarketName]="luckyDipMarketName">
                <ng-content select="your-call-body" ngProjectAs="your-call-body-details"></ng-content>
            </quickbet-selection>
        }
        @if (isState('receipt')) {
            <quickbet-receipt
                [selection]="selection"
                [betReceipt]="betReceipt"
                [ycOddsValue]="ycOddsValue"
                [isMobile]="device.isMobileOnly()"
                [racingPostToggle]="sysConfig.racingPostTip"
                [nextRacesToBetslipToggle]="sysConfig.nextRacesToBetslip?.enabled"
                [winAlertsEnabled]="sysConfig.winAlerts && sysConfig.winAlerts.enabled && device.isWrapper"
                (closeQuickbetPanel)="closePanel()"
                (reuseSelectionFn)="reuseSelection()"
                data-crlat="quickbetReceipt">
                <ng-content select="your-call-receipt" ngProjectAs="your-call-body-receipt-details"></ng-content>
            </quickbet-receipt>
        }
    </div>
    @if (quickDepositFormExpanded) {
        <lazy-component
            class="qb-quick-deposit-iframe"
            moduleUri="@quickDepositModule/quick-deposit.module#QuickDepositModule"
            [inputs]="{
                showPriceChangeNotification: showPriceChangeMessage,
                priceChangeBannerMsg: priceChangeText,
                estimatedReturn: +selection.potentialPayout,
                estimatedReturnAfterPriceChange: estimatedReturnAfterPriceChange,
                placeSuspendedErr: placeSuspendedErr,
                showSuspendedNotification: showSuspendedNotification,
                stake: getTotalStake(),
            }"
            [outputs]="['openIframeEmit', 'closeWindow', 'closeIframeEmit']"
            (event)="onQuickDepositEvents($event)"
            entryComponent="QuickDepositIframeComponent"
            data-crlat="quickDepositPanel">
        </lazy-component>
    }
</div>
